import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import ButtonIcon from 'components/ButtonIcon';
import { BusinessHealthResponse, HealthScoreOverallStatus } from '../types';
import Insight from './Insight';
import filterInsights from './helpers/filterInsights';
import normalizeStatus from './helpers/normalizeStatus';
import {
    InsightSectionContainer,
    InsightHeaderContainer,
    InsightSectionTitle,
    InsightsContainer,
} from './styled';

export interface InsightSectionWidgetProps {
    title: string;
    status: HealthScoreOverallStatus | HealthScoreOverallStatus[];
    isLoading?: boolean;
    data?: BusinessHealthResponse;
}

const InsightSectionWidget = ({
    title, status, isLoading, data,
}: InsightSectionWidgetProps) => {
    const [isOpen, setIsOpen] = useState(true);

    if (isLoading || !data) return null;

    const statusType = normalizeStatus(status);
    const insights = filterInsights(status, data);

    if (insights.length === 0) return null;

    return (
        <InsightSectionContainer>
            <InsightHeaderContainer>
                <InsightSectionTitle $status={statusType} $isOpen={isOpen}>
                    {`${title} (${insights.length})`}
                </InsightSectionTitle>
                <ButtonIcon
                    icon={isOpen ? <ChevronUp /> : <ChevronDown />}
                    size="small"
                    onClick={() => setIsOpen(!isOpen)}
                />
            </InsightHeaderContainer>
            <InsightsContainer $isOpen={isOpen}>
                {insights.map((insight) => {
                    const {
                        questionKey,
                        icon: IconComponent,
                        primaryMetrics,
                        metricsGroup,
                        scoreComponent,
                        primaryMetricsPresentation,
                        drawerMetricKeys,
                    } = insight;
                    const icon = IconComponent ? <IconComponent size={44} /> : undefined;
                    return (
                        <Insight
                            key={questionKey}
                            questionKey={questionKey}
                            question={insight.question}
                            headline={insight.headline}
                            summary={insight.summary}
                            insights={insight.insights}
                            icon={icon}
                            status={statusType}
                            data={data}
                            primaryMetrics={primaryMetrics ?? []}
                            metricsGroup={metricsGroup ?? ''}
                            scoreComponent={scoreComponent ?? ''}
                            primaryMetricsPresentation={primaryMetricsPresentation}
                            drawerMetricKeys={drawerMetricKeys}
                        />
                    );
                })}
            </InsightsContainer>
        </InsightSectionContainer>
    );
};

export default InsightSectionWidget;
